function bucketFromThreeplRequiredFields(rf: Record<string, unknown>): "LTL" | "FTL" | null {
  const hu = rf.handlingUnitList;

  if (Array.isArray(hu) && hu.length > 0) {
    return "LTL";
  }
  if (rf.shipmentMode === "Truckload") {
    return "FTL";
  }
  if (typeof rf.transportType === "string" && rf.transportType.trim() !== "") {
    return "FTL";
  }
  const stops = rf.stops;

  if (Array.isArray(stops) && stops.length >= 2) {
    return "FTL";
  }
  return null;
}

export function shipmentUiBucketFromUnifiedDoc(doc: object): "LTL" | "FTL" {
  const rec = doc as Record<string, unknown>;
  const mode = rec.mode;

  if (mode === "FTL") return "FTL";
  if (mode === "LTL") return "LTL";
  if (mode === "3PL") {
    const rf = rec.requiredFields;

    if (rf && typeof rf === "object" && !Array.isArray(rf)) {
      const inferred = bucketFromThreeplRequiredFields(rf as Record<string, unknown>);

      if (inferred) return inferred;
    }
    return "LTL";
  }
  return "LTL";
}
